import { languagesDataType } from "../../../interfaces/admin.interface";

interface ChangeLanguageProps {
  langCode: string;
  langs: languagesDataType[];
  setLangCode: (lang: string) => void;
  values: {
    translations: { lang_code: string }[];
  };
  setFieldValue: (field: string, value: any) => void;
}

const ChangeLanguage = ({
  langCode,
  setLangCode,
  values,
  setFieldValue,
  langs,
}: ChangeLanguageProps) => {
  const handleLanguageButtonClick = (lang: string) => {
    setLangCode(lang);
    const existingTranslation = values.translations.find(
      (t) => t.lang_code === lang
    );
    if (!existingTranslation && lang !== "AZ") {
      setFieldValue("translations", [...values.translations]);
    }
  };

  return (
    <div className="langs">
      {langs.map((lang, index) => {
        return (
          <div key={index}>
            <button
              className={lang.code === langCode ? "active_lang_btn" : ""}
              type="button"
              onClick={() => handleLanguageButtonClick(lang.code)}
            >
              {lang.name}
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default ChangeLanguage;
